import { render, staticRenderFns } from "./PartnerList.vue?vue&type=template&id=5114508a&"
import script from "./PartnerList.vue?vue&type=script&lang=js&"
export * from "./PartnerList.vue?vue&type=script&lang=js&"
import style0 from "./PartnerList.vue?vue&type=style&index=0&id=5114508a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports